import { render, staticRenderFns } from "./SendOnboardingLink.vue?vue&type=template&id=9b994438&scoped=true&"
import script from "./SendOnboardingLink.vue?vue&type=script&lang=js&"
export * from "./SendOnboardingLink.vue?vue&type=script&lang=js&"
import style0 from "./SendOnboardingLink.vue?vue&type=style&index=0&id=9b994438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b994438",
  null
  
)

export default component.exports